import HotelDirections from './HotelDirections.component';
import { HotelMap } from './components';
export default HotelDirections;
export { HotelMap };